"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMenuPopover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("@headlessui/react");
const classNames_1 = require("../../../utils/classNames");
// const TIMEOUT_DURATION = 400;
const NavigationMenuPopover = (props) => {
    const { panel: { name }, children, } = props;
    // let timeout: number;
    const buttonRef = (0, react_1.useRef)(null);
    // const [openState, setOpenState] = useState<boolean>(false);
    // const toggleMenu = () => {
    //   setOpenState((openState) => !openState);
    //   buttonRef?.current?.click();
    // };
    // Open menu after some delay of TIMEOUT_DURATION
    // const onHover = (open: boolean, action: string) => {
    //   if (
    //     (!open && !openState && action === 'onMouseEnter') ||
    //     (open && openState && action === 'onMouseLeave')
    //   ) {
    //     clearTimeout(timeout);
    //     timeout = window.setTimeout(() => toggleMenu(), TIMEOUT_DURATION);
    //   }
    // };
    // const handleClick = (open: boolean) => {
    //   setOpenState(!open);
    //   clearTimeout(timeout);
    // };
    const handleClickOutside = (event) => {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
            event.stopPropagation();
        }
    };
    (0, react_1.useEffect)(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_2.Popover, { className: "flex", children: ({ open }) => ((0, jsx_runtime_1.jsxs)("div", { className: "flex", children: [(0, jsx_runtime_1.jsx)("div", { className: "relative flex", children: (0, jsx_runtime_1.jsx)(react_2.Popover.Button, { ref: buttonRef, 
                        // onClick={() => handleClick(open)}
                        className: (0, classNames_1.cn)('relative', 'z-10', '-mb-px', 'flex', 'cursor-pointer', 'items-center', 'pt-px', 'transition-colors', 'duration-200', 'ease-out', 'lg:text-base', 'text-sm', 'ui-open:font-semibold', 'ui-open:text-primary-700', 'ui-open:underline-offset-4', 'ui-open:underline', 'ui-open:decoration-2', 'ui-not-open:border-transparent', 'hover:text-primary-700', 'text-gray-700', 'hover:underline', 'hover:decoration-2', 'hover:underline-offset-4', 'outline-none', 'focus:text-primary-700', 'focus:underline-offset-4', 'focus:underline', 'focus:decoration-2'), children: name }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_2.Transition, { as: react_1.Fragment, show: open, enter: "transition ease-out duration-200", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "transition ease-in duration-150", leaveFrom: "opacity-100", leaveTo: "opacity-0", children: (0, jsx_runtime_1.jsx)(react_2.Popover.Panel, { static: true, className: "absolute inset-x-0 top-full z-10 mt-1 bg-white", children: children }) }) })] })) }));
};
exports.NavigationMenuPopover = NavigationMenuPopover;
